import TrucksRatio from "./TrucksRatio";

export default TrucksRatio;
